import { render, staticRenderFns } from "./stuScore.vue?vue&type=template&id=8c745e5c&scoped=true&"
import script from "./stuScore.vue?vue&type=script&lang=js&"
export * from "./stuScore.vue?vue&type=script&lang=js&"
import style0 from "./stuScore.vue?vue&type=style&index=0&id=8c745e5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c745e5c",
  null
  
)

export default component.exports